import epsClient from '../../../api/enrollment-platform-client/api-client'
import { BenefitQueueData } from '../types/benefitQueue'

export async function fetchBenefitQueue(
  assignee: string
): Promise<BenefitQueueData[]> {
  const response = await epsClient.get(`/benefits/assignee/${assignee}`)
  return response.data
}
